// Sites
const sites = {
    ONLINE: 'ONLINE',
    VIRTUAL: 'VIRTUAL',
    LGH: 'LGH',
    RH: 'RH',
    VGH: 'VGH',
    PR: 'PR',
    SECHELT: 'SECHELT',
}

// Human-readable strings
const siteNames = {
    ONLINE: 'Online',
    VIRTUAL: 'Virtual',
    LGH: 'Lion\'s Gate Hospital',
    RH: 'Richmond Hospital',
    VGH: 'Vancouver General Hospital',
    PR: 'Powell River',
    SECHELT: 'Sechelt',
}

Object.freeze(sites);
Object.freeze(siteNames);

export default sites;
export {
    sites as SITES,
    siteNames as SITE_NAMES,
}